<template lang="pug">
#popup.componente-popup-tooltip(v-if='propriedade && propriedade.codigo')
    div(style='display: flex; justify-content: space-between')
        h4 {{ $t('mensagens.menuMapa.labels.informacoesImovel') }}
        i.mdi.mdi-close.font-weight-bold(
            @click.stop='closePopUp',
            style='cursor: pointer'
        )

    h5(style='margin: 10px 0 10px 0') {{ propriedade.codigo }}

    div
        strong {{ $t('mensagens.menuMapa.labels.situacao') }}:
        span {{ propriedade.situacao }}
    div
        strong {{ $t('mensagens.menuMapa.labels.area') }}:
        span {{ areaFormatada }} ha
    div
        strong {{ $t('mensagens.menuMapa.labels.localidade') }}:
        span {{ propriedade.nome_municipio ? propriedade.nome_municipio : '' }} / {{ propriedade.uf }}

    .btn-adicionar-container
        BaseButton.colorButton(
            type='success',
            icon='el-icon-plus',
            size='small',
            @click.stop='adicionarImovel'
        ) {{ $t('mensagens.menuMapa.labels.adicionar') }}
</template>
<script>
import EventBus from '@/utils/eventBus';
import store from '@/store';
import BaseButton from '@/components/vegaComponents/BaseButton.vue';

export default {
    name: 'PopupCarSelecionadoNoMapa',

    components: {
        BaseButton
    },
    
    data() {
        return {
            propriedade: {}
        };
    },

    methods: {
        atualizarPropriedades(data) {
            this.propriedade = null;
            if (data) {
                this.propriedade = data.properties;
            }
        },

        adicionarImovel() {
            store.dispatch('setCarSelecionadoNaPopup', this.propriedade.codigo);
            store.dispatch('setLimparUltimaGeometria', true);
            EventBus.$emit(
                'mapa:setar-car-especificado',
                true
            );
            this.propriedade = null;
        },
        closePopUp() {
            store.dispatch('setLimparUltimaGeometria', true);
            this.propriedade = null;
        },
        decodeUtf8(municipioFormater) {
            return decodeURIComponent(escape(municipioFormater));
        },
        skip() {}
    },
    computed: {
        areaFormatada() {
            return this.propriedade.areaHa
                ? this.propriedade.areaHa.toFixed(2)
                : null;
        },
        carSelecionadoNaPopup() {
            return store.state.carSelecionadoNaPopup;
        },
        ativarCamadaCar() {
            return store.state.ativarCamadaCar;
        }
    },
    watch: {
        ativarCamadaCar: {
            handler(val) {
                if (!val) {
                    this.closePopUp();
                }
            },
            immediate: false
        },
        carSelecionadoNaPopup: {
            handler(val) {
                if (!val) {
                    this.closePopUp();
                }
                this.atualizarPropriedades(val);
            },
            immediate: false
        }
    }
};
</script>
<style lang="scss" scoped>
.componente-popup-tooltip {
    padding: 10px;
    width: 320px;
    background-color: var(--white);
    border-radius: 4px;

    strong {
        margin-right: 4px;
    }

    .btn-adicionar-container {
        margin-top: 10px !important;
        display: flex;
        justify-content: flex-end;
    }
    .btn-adicionar-container i {
        margin-right: 0px !important;
    }
    .btn-adicionar-container button {
        width: 100px !important;
    }
}

.colorButton {
    background-color: #67c23a;
    color: var(--white);
}

.colorButton:hover {
    background-color: #85ce61;
    color: var(--white);
}

.leaflet-touch .leaflet-bar button {
    line-height: 16px;
}

.fontButton {
    line-height: 16px;
}
</style>
